import { PaletteColorOptions, TypeBackground } from "@mui/material";

export interface IContext {
  veryLight?: string;
  light?: string;
  main?: string;
  dark?: string;
  black?: string;
  white?: string;
  primary?: string;
  secondary?: string;
  tertiary?: string;
}

export const primary: PaletteColorOptions = {
  main: "#1F56A3",
  dark: "#153D76",
  light: "#7FA4D8",
  shade: "#E2EEFF",
  contrastText: "#F6F6FF",
};

export const secondary: PaletteColorOptions = {
  main: "#CB1150",
  dark: "#931846",
  light: "#E5437A",
  shade: "#FFD9E6",
  contrastText: "#F6F6FF",
};

export const tertiary: PaletteColorOptions = {
  main: "#FE7D07",
  dark: "#FEA14A",
  light: "#FDB16A",
  shade: "#FFEAD7",
  contrastText: "#F6F6FF",
};

export const error: PaletteColorOptions = {
  main: "#DC3545",
  light: "#FFEDEF",
};

export const info: PaletteColorOptions = {
  main: "#0DA7A7",
  light: "#EDFFFF",
};

export const success: PaletteColorOptions = {
  main: "#20BC7A",
  light: "#E9FFF6",
};

export const warning: PaletteColorOptions = {
  main: "#FAC641",
  light: "#FFF9EA",
};

export const context: IContext = {
  primary: "#13305D",
  secondary: "#560322",
  tertiary: "#99510D",
  veryLight: "#D1D3DA",
  light: "#979BA5",
  dark: "#595D6B",
  black: "#111629",
  white: "#F6F6FF",
};

export const background: TypeBackground = {
  default: "#EEEEEF",
  paper: "#FEFEFF",
};

export { grey, blue } from "@mui/material/colors";
